import { TutorialStep } from "..";

export const ReportCreateSteps: TutorialStep[] = [
  {
    target: "#report-template-0",
    content: `리포트는 템플릿으로 시작합니다.\n'종합 리포트'를 선택해보세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#create-report-btn",
    content: `구성될 항목들을 미리 확인할 수 있습니다.\n생성 버튼을 눌러 리포트를 만들어보세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "top",
    disableOverlayClose: true,
  },
  {
    target: "#add-report-content",
    content: `이렇게 템플릿만으로도 리포트가 완성됩니다.\n여기서 원하는 항목을 더 추가할 수도 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#save-report-btn",
    content: `저장 버튼을 눌러 지금 구성을 저장하세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#print-report-btn",
    content: `프린터 아이콘으로 작성한 리포트를 PDF로 내보낼 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#report-setting-menu",
    content: `좌측 '설정'에서 색상 테마, 클래스 필터, 템플릿 등을\n원하는 대로 커스텀할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "right",
    disableOverlayClose: true,
  },
];
